import { stringify } from 'qs';
import { omit, set, inRange, isEmpty, getOr } from 'lodash/fp';
import { call } from 'redux-saga/effects';
import { UserToken } from '../../../helpers/config';

const namespace = 'rest-api';
const baseUrl = `/${namespace}`;

const isGetRequest = method => getOr('GET', method) === 'GET';

const reloadPageWithDelay = (delay = 2000) =>
  setTimeout(() => {
    window.location.reload();
  }, delay);

export const prepareRequestOptions = (options = {}) => {
  const { skipAuth } = options;
  return {
    ...omit(['qs', 'skipAuth'], options),
    ...(skipAuth ? { credentials: 'same-origin' } : {}),
    headers: {
      ...(skipAuth ? {} : { Authorization: `Bearer ${UserToken}` }),
      'Content-Type': 'application/json'
    },
    ...(isGetRequest(options.method) || isEmpty(options.body)
      ? {}
      : { body: JSON.stringify(options.body) })
  };
};

export const composeRequestUrl = (uri, options = {}) => {
  const query = stringify(options.qs || {});
  return query ? `${baseUrl}/${uri}?${query}` : `${baseUrl}/${uri}`;
};

export default function* apiRequest(uri, options = {}) {
  const fetchOptions = prepareRequestOptions(options);
  const url = composeRequestUrl(uri, options);

  const response = yield call(fetch, url, fetchOptions);
  const body = yield call([response, 'json']);
  /* eslint-enable */

  if (response.status === 401) {
    if (!options.skipAuth) {
      reloadPageWithDelay();
      throw set('message', 'Auth token expired. Reloading...', body);
    }
    throw body; // eslint-disable-line no-throw-literal
  }

  if (!inRange(100, 299, response.status)) {
    throw body; // eslint-disable-line no-throw-literal
  }
  return body;
}

export async function fetchBlob(uri, options = {}) {
  const fetchOptions = prepareRequestOptions(options);
  const url = composeRequestUrl(uri, options);
  const response = await fetch(url, fetchOptions);

  if (response.status === 401) {
    reloadPageWithDelay();
    const body = await response.json();
    throw set('message', 'Auth token expired. Reloading...', body);
  }

  if (!inRange(100, 299, response.status)) {
    const body = await response.json();
    throw body;
  }

  const blob = await response.blob();
  return blob;
}
